import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Subtract({ idVariant = '', className }: Props) {
  return (
    <IconBase name="subtract" w={24} className={className}>
      <path d="M5 11.5V12.5H19V11.5H5Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Subtract
